var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyBoxIcon = function SvgEmptyBoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-box-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    fillRule: "evenodd",
    d: "m31.832 9.445-4-6a1 1 0 0 0-.653-.43l-11-2h-.016l-.016-.001q-.073-.008-.147-.006-.074-.002-.146.007h-.015q-.01 0-.017.002l-11 2a1 1 0 0 0-.654.428l-4 6A1 1 0 0 0 1 11h11c.379 0 .725-.214.895-.553L16 4.236l3.105 6.21c.17.34.516.554.895.554h11a1 1 0 0 0 .832-1.555M20 13a2.99 2.99 0 0 1-2.683-1.656L17 10.709v19.935l10.414-4.734A1 1 0 0 0 28 25V13zm-5.316-1.658.316-.633v19.935L4.586 25.91A1 1 0 0 1 4 25V13h8c1.143 0 2.17-.635 2.684-1.658",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-box-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgEmptyBoxIcon;